const overview = {
	bttn_create: "Create Tuxis daDup",
	card: {
		body: {
			datastore_name: "Datastore name",
			description: "Description",
			free_version: "Free version",
			hostname: "daDup host",
			in_use: "In use",
			location: "Server location",
			name: "Display name",
			new: "Recently created",
			username: "Username",
		},
		footer: {
			bttn: "Show details",
		},
	},
	empty: "You don't have a Tuxis daDup account yet",
	title: "Tuxis daDup overview",
};

const cancelDialog = {
	description:
		"When you cancel this service it will be terminated and all data will be permanently deleted. To confirm, please repeat the name of the daDup <strong>{{username}}</strong> below",
	label: "Username",
	placeholder: "The username you use to log in to daDup.",
	submit_button: "Delete daDup account",

	success_message: "daDup canceled successfully!",
	title: "Delete daDup account",
};

const page = {
	current_usage: {
		in_use: "Currently in use",
		title: "Current usage",
	},
	delete_button: "Cancel daDup",

	info_tile: {
		description: "Description",
		host: "daDup Host",
		location: "Server location",
		name: "Display name",

		relation_title: "Linked relation",
		title: "daDup information",
		username: "Username",
	},
	password_tile: {
		credentials_saved_button: "I've saved the credentials",
		description:
			"The credentials are stored in the password vault for <strong>30 days</strong>. Save these details in your own password manager.",
		description_completed:
			"You've saved the credentials from the password vault to your password manager.",
		password_vault_button: "Go to password vault",
		request_credentials: "Lost credentials? Request new credentials.",
		title: "daDup login credentials",
	},
	title: "Tuxis daDup account information",
};
const bucket = {
	add_button: "Add bucket",
	create_dialog: {
		description: "This creates a bucket within your daDup account; choose an appropriate name.",
		label: "Bucket name",
		placeholder: "e.g., bucket01",
		success: "Bucket requested successfully! This may take a few minutes.",
		title: "Add bucket",
	},
	delete_dialog: {
		description:
			"When you delete the bucket <strong>{{name}}</strong>, all data will be permanently removed and this action cannot be undone. Are you sure?",
		label: "Bucket name",
		placeholder: "The bucket name",
		submit: "Delete bucket",
		success: "Bucket deleted successfully!",
		title: `Delete bucket '{{name}}'`,
	},
	table: {
		title: "Buckets",
	},
};

const manage = {
	bucket: bucket,
	cancel_dialog: cancelDialog,
	mange: "Manage daDup",
	overview: overview,
	page: page,
};

export default manage;
